import React, { useState, useEffect } from "react";
import { DataTable, Modal } from "../../components";
import { Link, Redirect } from 'react-router-dom';
import {
  getMeasurements,
  deleteMeasurementById,
  getCustomers,
  getLocationsByCustomerId,
  getMeasurementsByCustomerId,
  getMeasurementsByLocationId,
  exportAllMeasurementsToCsv,
} from '../../services';

const Measurements = () => {

  const [measurements, setMeasurements] = useState();
  const [refresh, setRefresh] = useState(false);
  const [customer, setCustomer] = useState(false);
  const [location, setLocation] = useState(false);
  const [customerArray, setCustomerArray] = useState(false);
  const [locationArray, setLocationArray] = useState(false);
  const [deleteMeasurementId, setDeleteMeasurementId] = useState();

  const openModal = (measurementId) => {
    document.querySelector('.overlay').classList.toggle('modal__active');
    setDeleteMeasurementId(measurementId)
  }

  const deleteMeasurement = () => {
    deleteMeasurementById(deleteMeasurementId).then(() => {
      document.querySelector('.overlay').classList.toggle('modal__active');
      setRefresh(true)
    })
  }

  useEffect(() => {
    // Measurements
    getMeasurements().then((res) => updateTable(res.measurements));
    // Customerlist
    getCustomers().then(res => {
      const options = res.customers.map((x) => <option value={x.id}>{x.name}</option>);
      setCustomerArray(options)
    })
  }, [refresh]);

  useEffect(()=> {
    if(customer > 0 ) {
      getLocationsByCustomerId(customer).then(res => {
        const options = res.locations.map((x) => <option value={x.id}>{x.name}</option>);
        setLocationArray(options)
      })
      setLocation(0)
      getMeasurementsByCustomerId(customer).then(res => updateTable(res.measurements))
    }
  },[customer])

  useEffect(() => {
    if (location > 0) {
      getMeasurementsByLocationId(customer, location).then(res => updateTable(res.measurements))
    }
  }, [location])

  const updateTable = (measurements) => {
    // set measurements from api request
    console.log(measurements)
    const body = [];
    measurements.map((measurement, i) => {
      const editIcon = <Link className="icon__edit" to={"measurements/edit/"+measurement.id}><i style={{marginRight: 30}} className="fas fa-pencil-alt"></i></Link>;
      const deleteIcon = <a onClick={() => openModal(measurement.id)} className="icon__delete"><i className="fas fa-trash-alt"></i></a>;
      const actionRow = <div>{editIcon}{deleteIcon}</div>
      const row = [
        new Date(measurement.date).toLocaleDateString('nl-NL', { year: 'numeric', month: '2-digit', day: '2-digit' }),
        measurement.customer_name,
        measurement.location_name,
        measurement.department_name,
        actionRow
      ];
      body.push(row);
    });
    setMeasurements(body);
  }

  const downloadCsv = async () => {
    await exportAllMeasurementsToCsv(location);
  }

  const head = ["Datum", "Klant", "Locatie", "Afdeling", "Acties"];
  if (measurements) {
    return (
      <div className="container">
        <Modal header="Weet je zeker dat je deze derving wilt verwijderen?">
          <button onClick={deleteMeasurement} className="button__delete">Verwijderen</button>
        </Modal>
        <h2 className="container__title">Dervingsregistraties</h2>
        <div className="form__container">
          <div style={{paddingBottom: 0}} className="form__fields nowrap">
          <div className="form__fields__field">
            <span className="form__fields__field__label">Klant</span>
            <select
              required="true"
              id="selectbox__location"
              onChange={(e) => setCustomer(e.target.value)}
              className="form__fields__field__input"
            >
              <option value="0">Selecteer een klant</option>
              {customerArray}
            </select>
          </div>
          {customer &&
          <div className="form__fields__field">
            <span className="form__fields__field__label">Locatie</span>
            <select
              required="true"
              value={location}
              id="selectbox__location"
              onChange={(e) => setLocation(e.target.value)}
              className="form__fields__field__input"
            >
              <option value="0">Selecteer een locatie</option>
              {locationArray}
            </select>
          </div>
          }
          {location &&
            <div className="form__fields__field">
              <button onClick={downloadCsv} className="form__container__content__button nomargin">
                Exporteer <i className="fas fa-download"></i>
              </button>
            </div>
          }
        </div>
          <DataTable style={{marginTop: 0}} head={head} body={measurements}/>
        </div>
        {refresh && <Redirect to="/measurements" />}
      </div>
    );
  } else return <div></div>;
}

export default Measurements;
